import { ProgramMatchingScreen } from '@/components/ProgramMatchingScreen';

export default function ProgramMatching() {
  return <ProgramMatchingScreen />;
}
